// extracted by mini-css-extract-plugin
export default {"container":"bottomBuyPopup_container__4kXTb","title":"bottomBuyPopup_title__QJcXK","buyButtonContainer":"bottomBuyPopup_buyButtonContainer__mzsaE"};